import { render, staticRenderFns } from "./ParentPassword.vue?vue&type=template&id=779d37ac&"
import script from "./ParentPassword.vue?vue&type=script&lang=js&"
export * from "./ParentPassword.vue?vue&type=script&lang=js&"
import style0 from "./ParentPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports